import { eCurrency } from '@logicalcommander/types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface ICurrencyState {
  currency: eCurrency
}

const initialState: ICurrencyState = {
  currency: eCurrency.USD, // Default currency
}

const currencySlice = createSlice({
  name: 'currencyReducer',
  initialState,
  reducers: {
    setCurrency: (state, action: PayloadAction<eCurrency>) => {
      state.currency = action.payload
    },
  },
})

export const { setCurrency } = currencySlice.actions
export const selectCurrency = (state: RootState): eCurrency => state.currencyReducer.currency
export default currencySlice.reducer
